import "../styles/css/reset.scss";
import "../styles/css/fonts.scss";
import "../styles/css/helpers.scss";
import "../styles/css/main.scss";
import { trackEvent } from "./analytics";
import { displayData, getIOsVersion, runThreeJs } from "./helpers";

let showPlaceholderTimer;

async function getData(qr) {
  const productResponse = {
    data: null,
    error: null,
  };
  try {
    const data = await checkQrCode(qr);
    if (!data.ok) {
      productResponse.error = data.status;
      throw new Error(data.status);
    }
    productResponse.data = await data.json();
    if (productResponse.data?.redirectLink) {
      window.location.href = productResponse.data?.redirectLink;
      return;
    }
  } catch (e) {
    console.log("Error: ", e);
    trackEvent("check_qr_error", { error: e.message });
    productResponse.error = e.message;
  }
  return productResponse;
}

async function refreshProductData(qr) {
  try {
    const productResponse = await getData(qr);
    if (productResponse?.data && !productResponse.error) {
      displayData(productResponse.data, qr);
    }
  } catch (e) {
    console.error("Refresh Data Error: ", e);
  }
}

// QR code is passed as a query parameter
async function init(qr) {
  try {
    if (qr) {
      const body = document.querySelector(".body");
      body.style.display = 'flex';
      await showLoyaltyInfo(qr);
    } else {
      showDiv(".empty");
      throw new Error("QR code is missing");
    }
  } catch (e) {
    console.error("Initialization Error: ", e);
  }
}

async function onContentLoaded() {
  const isMainPage = window.location.pathname === "/";
  const isPathName = window.sessionStorage.getItem("pathName");

  if (isMainPage && isPathName) {
    window.location.assign(window.sessionStorage.getItem("pathName"));
  }

  const qr = 
    location?.href?.split?.("qr/")?.[1] || location?.search?.split?.("?qrId=")?.[1];

  if (qr) {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        refreshProductData(qr);
      }
    });
  }

  init(qr);
}

async function showLoyaltyInfo(qr) {
  const productResponse = await getData(qr);

  const isLatestBuggyIos16 = isBuggyIos16();
  if (!isLatestBuggyIos16) {
    showPlaceholderTimer = setTimeout(showPlaceholder, 350);
  }

  window.sessionStorage.setItem("pathName", location.pathname);
  if (productResponse.data && !productResponse.error) {
    loadAndShowModel(isLatestBuggyIos16, productResponse, qr);
  } else {
    hideDiv(".wrapper");
    showDiv(".empty");
  }
}

function trackTestResultsButtonClick() {
  trackEvent("test_results_button_click");
}

function trackRedeemButtonClick(productResponse) {
  trackEvent("redeem_button_click", {
    points: productResponse.data.brandPoints,
  });
}

function loadAndShowModel(isLatestBuggyIos16, productResponse, qr) {
  hideDiv(".empty");

  assignOnClickById("test-results-button", trackTestResultsButtonClick);
  assignOnClickById("redeem-button", () =>
    trackRedeemButtonClick(productResponse)
  );

  if (isLatestBuggyIos16) {
    showProductPreview(productResponse);
  } else {
    renderModel(productResponse);
  }
  displayData(productResponse.data, qr);
  showDiv(".wrapper");
}

function renderModel(productResponse) {
  const defaultPosition = {
    x: 0.0028091313521602023,
    // eslint-disable-next-line no-loss-of-precision
    y: 0.09905276630822155,
    z: 0.7428539023616042,
  };
  const threeVector = { x: 0.2, y: 0.2, z: 0.14 };
  const modelUrl = productResponse?.data?.modelGlb?.url;

  trackEvent("show_model_start", {
    modelUrl,
  });
  runThreeJs(modelUrl, defaultPosition, threeVector, true)
    .then(() => {
        trackEvent("show_model_success", {
          modelUrl,
        });
      setTimeout(() => {
        hidePlaceholder();
        setTimeout(() => showPlaceholder(".box2"), 200);
      }, 350);
    })
    .catch((e) => {
      console.log("Error: ", e);
      trackEvent("show_model_error", {
        error: e.message,
        modelUrl,
      });
      showProductPreview(productResponse);
      hidePlaceholder();
    });
}

function showProductPreview(productResponse) {
  const imgPreview = document.querySelector(".imagePreview");
  imgPreview.src = productResponse.data?.images?.[0]?.file?.url;
  imgPreview.classList.remove("display__none");
  trackEvent("image_preview_shown");
}

function showPlaceholder(selector) {
  const placeholder = document.querySelector(
    selector || ".wrapper--placeholder"
  );
  placeholder.classList.remove("opacityZero");
}

function hidePlaceholder() {
  clearTimeout(showPlaceholderTimer);
  const placeholder = document.querySelector(".wrapper--placeholder");
  placeholder.classList.add("opacityZero");
}

function showDiv(selector) {
  const div = document.querySelector(selector);
  div.classList.remove("display__none");
}

function hideDiv(selector) {
  const div = document.querySelector(selector);
  div.classList.add("display__none");
}

/**
 * @returns {boolean}
 * @description
 * iOS 16.4.0 and 16.4.1 have a bug with three.js and glb files. The model texture is not rendered.
 */
function isBuggyIos16() {
  const [major, minor, path] = getIOsVersion();
  return major === 16 && minor === 4 && [0, 1].includes(path);
}

async function checkQrCode(qr) {
  return window.fetch(
    `${process.env.API_HOST}/v2/product-qr-code/check`,
    {
      method: "POST",
      body: JSON.stringify({ uniqueString: qr }),
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    },
    { mode: "no-cors" }
  );
}

/**
 * @param {string} id - id of the element
 * @param {function} callback - callback function
 * @description
 * Assigns a callback function to the element with the given id. If the element is not found, nothing happens.
 * @example
 * assignOnClickById("myButton", () => console.log("Button clicked!"));
 */
function assignOnClickById(id, callback) {
  const element = document.getElementById(id);
  if (element) {
    element.onclick = callback;
  }
}

document.addEventListener("DOMContentLoaded", onContentLoaded);
